export default __webpack_public_path__ + "static/media/tinder_footer.5e397de0.svg";